import React from 'react';

export const TrophyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9a9.75 9.75 0 01-4.874-1.917 2.25 2.25 0 01-.625-3.029 2.25 2.25 0 013.029-.625A7.5 7.5 0 009.75 15h4.5a7.5 7.5 0 003.82-1.012 2.25 2.25 0 013.029.625 2.25 2.25 0 01-.625 3.029A9.75 9.75 0 0116.5 18.75z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 12.75h4.5m-4.5 0a.75.75 0 01.75-.75h3a.75.75 0 01.75.75m-4.5 0v-.75a3.375 3.375 0 013.375-3.375h.75a3.375 3.375 0 013.375 3.375v.75m-9-3.75h9m-9 0a2.25 2.25 0 01-2.25-2.25v-1.5a2.25 2.25 0 012.25-2.25h9a2.25 2.25 0 012.25 2.25v1.5a2.25 2.25 0 01-2.25 2.25h-9z" />
  </svg>
);
